import type { User } from '@auth0/auth0-spa-js';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { FrontendLoggerService } from '../frontend-logger.service';

export type LoginType = 'interactive' | 'silent' | 'failed';
type ProfileReader = () => Observable<User | null>;

export class AuthLoginHistoryRecorder {
  private registered = false;

  constructor(
    private readonly apiService: ApiService,
    private readonly logger: FrontendLoggerService
  ) {}

  register(
    success: boolean,
    loginType: LoginType,
    profileReader: ProfileReader
  ): void {
    profileReader().subscribe((user) => {
      const body = {
        userId: user?.sub || user?.['id'] || '',
        success,
        userAgent: navigator.userAgent,
        loginTime: new Date().toISOString(),
        location: globalThis.location?.href ?? '',
        loginType,
      };
      this.apiService.post('auth/login-history', body).subscribe({
        next: () => this.logger.debug('Login history registrado', loginType),
        error: (error) => {
          this.logger.error(
            'Error login-history post',
            error?.message || JSON.stringify(error)
          );
        },
      });
    });
  }

  registerOnce(profileReader: ProfileReader): void {
    if (this.registered) return;
    this.registered = true;
    this.logger.debug('Registrando login silencioso único', 'start');
    this.register(true, 'silent', profileReader);
  }
}
